/* Page-only progressive anchors. No catalogue, price, cart or rental-app mutation. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.tnl-sl-choices a').forEach(link => {
    link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      history.pushState(null, '', link.hash);
      target.scrollIntoView({behavior: reduced.matches ? 'instant' : 'smooth', block: 'start'});
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    });
  });
})();
